import type { FC } from 'react';
import { Link } from 'umi';
import { LOGO_IMG } from '@/utils/constant';
import { trace } from '@/utils/trace';

type IProps = {
  title?: string;
  name?: string;
};

const PayHeader: FC<IProps> = ({ title, name }) => {
  const handleTrace = () => {
    trace('btn_click', {
      btn_name: '商城logo',
      desc: '商城logo,点击跳转',
      link_page_url: '/',
    });
  };
  return (
    <>
      <div className="border-b border-t-[10px] border-solid border-[#FF4A00]  w-[100%]" />
      <div className="2xl:container my-0 mx-auto">
        <div className="py-[18px] flex justify-between items-center border-b border-solid border-[#B9B9B9]">
          <div className="inline-flex items-center">
            <Link to="/" onClick={handleTrace}>
              <img
                className="w-[116px] cursor-pointer"
                src={LOGO_IMG}
                alt="beukay-logo"
              />
            </Link>
            {!!title && (
              <span className="ml-5 text-20 font-medium">{title}</span>
            )}
          </div>
          <div className="flex flex-row items-center">
            <div className="text-20 font-normal cursor-pointer]">{name}</div>
            <span className="w-[2px] h-[18px] bg-[#141414] mx-[10px] radius-[5px]" />
            <Link
              to="/manage/oc"
              className="text-20 font-normal cursor-pointer"
            >
              我的订单
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayHeader;
